package com.mshopsas.enterprise.aiw.scan.data.basket

import kotlinx.serialization.Serializable

@Serializable
data class FavouriteStore(
    var id: Int,
    var label: String,
)